import React, { createContext, useContext, useReducer } from 'react';
import Stores from './Stores';
// Initial state
const initialState = {
  theme: 'light',
  language: localStorage.getItem('language') || navigator.language?.split('-')[0] || 'en',
  pathAfterLogin: '/reports',
  modal: {
    open: false,
    title: '',
    description: '',
    children: null,
  },
  notification: {
    show: false,
    message: '',
  },
  sidebarSearch: '',
  ...Object.assign({}, ...Stores.map(store => store.initialState)),
  // Add any other global state you need
};

// Action types
export const ActionTypes = {
  TOGGLE_THEME: 'TOGGLE_THEME',
  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_PATH_AFTER_LOGIN: 'SET_PATH_AFTER_LOGIN',
  SET_MODAL: 'SET_MODAL',
  SET_NOTIFICATION: 'SET_NOTIFICATION',
  SET_SIDEBAR_SEARCH: 'SET_SIDEBAR_SEARCH',
};

// Reducer function
function appReducer(state, action) {
  // Start with the current state
  let newState = {...state};
  
  // Let each store process the action
  Stores.forEach(store => {
    // Update newState with the result from each store's reducer
    newState = store.reducer(newState, action);
  });

  // Handle global actions
  switch (action.type) {
    case ActionTypes.TOGGLE_THEME:
      return {
        ...newState,
        theme: newState.theme === 'light' ? 'dark' : 'light',
      };
    case ActionTypes.SET_LANGUAGE:
      return {
        ...newState,
        language: action.payload,
      };
    case ActionTypes.SET_PATH_AFTER_LOGIN:
      return {
        ...newState,
        pathAfterLogin: action.payload,
      };
    case ActionTypes.SET_MODAL:
      return {
        ...newState,
        modal: action.payload,
      };
    case ActionTypes.SET_NOTIFICATION:
      return {
        ...newState,
        notification: action.payload,
      };
    case ActionTypes.SET_SIDEBAR_SEARCH:
      return {
        ...newState,
        sidebarSearch: action.payload,
      };
    default:
      return newState;
  }
}

// Create context
const AppStateContext = createContext();
const AppDispatchContext = createContext();

// Provider component
export function AppStoreProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>
        {children}
      </AppDispatchContext.Provider>
    </AppStateContext.Provider>
  );
}

// Custom hooks to use the store
export function useAppState() {
  const context = useContext(AppStateContext);
  if (context === undefined) {
    throw new Error('useAppState must be used within an AppStoreProvider');
  }
  return context;
}

export function useAppDispatch() {
  const context = useContext(AppDispatchContext);
  if (context === undefined) {
    throw new Error('useAppDispatch must be used within an AppStoreProvider');
  }
  return context;
}